import Carousel from "@stimulus-components/carousel"

export default class extends Carousel {
  connect() {
    super.connect()
  }

  get defaultOptions() {
    return {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        disabledClass: 'swiper-btn-disabled',
        hiddenClass: 'swiper-button-hidden'
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction'
      }
    }

  }
}
